import * as api from '@owl-nest/api-client/latest'

export async function create(
  projectId: number | string,
  payload: api.CreateSubscription,
): Promise<api.ApiResponse<api.Subscription>> {
  const response = await api.api.post.projectSubscriptions({
    body: payload,
    urlParams: {
      projectId: String(projectId),
    },
  })

  return response.next((success) => {
    return success.body
  })
}

export async function cancel(subscriptionId: number): Promise<api.ApiResponse<api.Subscription>> {
  const response = await api.api.post.cancelSubscription({
    urlParams: { subscriptionId: String(subscriptionId) },
  })

  return response.next((success) => success.body)
}
